import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,Box
} from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { useAuth } from "../../../../AuthProvider"; 
import { GlobalStyles } from "@mui/system";



function TransportComplaints() {
 
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [newComplaint, setNewComplaint] = useState({ 
    date: new Date().toISOString().split("T")[0], // Default to today's date,
    complaintRaisedName: "",
    complaintDescription: "",
    status: "" });
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const { userId, oId ,userRoleName} = useAuth(); 
  const [loading, setLoading] = useState(false);

  const [searchDate, setSearchDate] = useState(""); // State to store selected date


 

  
    const fetchComplaints = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${baseUrl}/api/complaints/getComplaint/${userId}/${oId}`);
  
        if (response.status === 200) {
          setFilteredData(response.data); // Update state with fetched data
        } else {
          console.error("Failed fetching complaints:");
          // toast.error("Failed to fetch complaints.");
        }
      } catch (error) {
        console.error("Error fetching complaints:", error);
        // toast.error("An error occurred while fetching data.");
      } finally {
        setLoading(false);
      }
    };
    useEffect(() => {
    fetchComplaints();
  }, []);
  

  //  // Filter data based on searchQuery
  //  const filteredResults = filteredData.filter((item) => {
  //   const name = item.complaintRaisedName ? item.complaintRaisedName.toLowerCase() : ""; // Ensure name is lowercase for case-insensitive search
    
  //   return name.includes(searchQuery.toLowerCase()); // Filter by name only
  // });
  const filteredResults = filteredData.filter((item) => {
    if (!searchDate) return true; // If no date is selected, show all results
  
    return item.date === searchDate; // Filter based on exact date match
  });
  
  

  const handleAddNewClick = () => {
    setDialogOpen(true);
  };


  const handleDialogClose = () => {
    setDialogOpen(false);
   
  };


  const [errors, setErrors] = useState({
    date: false,
    complaintRaisedName: false,
    complaintDescription: false,
  });
  const handleInputChange = (field, value) => {
    setNewComplaint((prev) => ({ ...prev, [field]: value }));
  
    // Clear error when user starts typing in a field
    setErrors((prevErrors) => ({ ...prevErrors, [field]: !value }));
  };


  const handleSaveNewComplaint = async () => {
    // Validate form before submission
    let newErrors = {
      date: !newComplaint.date,
      complaintRaisedName: !newComplaint.complaintRaisedName,
      complaintDescription: !newComplaint.complaintDescription,
    };
  
    setErrors(newErrors);
  
    if (Object.values(newErrors).some((error) => error)) {
      console.log("Please fill in all required fields.")
      // toast.error("Please fill in all required fields.");
      return;
    }
  
    setLoading(true); // Start loading
  
    // Create a FormData object
    const formData = new FormData();
    formData.append("date", newComplaint.date);
    formData.append("complaintRaisedName", newComplaint.complaintRaisedName);
    formData.append("complaintDescription", newComplaint.complaintDescription);
  
    try {
      const response = await fetch(
        `${baseUrl}/api/complaints/saveComplaint/${userRoleName}/${userId}`,
        {
          method: "POST",
          body: formData,
        }
      );
  
      if (response.ok) {
        fetchComplaints();
        toast.success("Complaint Raised successfully!");
        handleDialogClose(); // Close the dialog
      } else {
        toast.error("Failed to Raise complaint. Please try again.");
      }
    } catch (error) {
      console.error("Error saving complaint:", error);
      toast.error("An error occurred. Please try again later.");
    } finally {
      setLoading(false); // Stop loading
    }
  };
  

  

  const getStatusColor = (status) => {
    const normalizedStatus = status?.trim().toLowerCase(); // Normalize input
    console.log("Status:", status, "Normalized:", normalizedStatus); // Debugging log
  
    switch (normalizedStatus) {
      case "pending":
        return "#FF8C00"; // Dark orange for pending
      case "resolved":
        return "#2E8B57"; // Sea green for resolved
      case "in progress":
        return "#4682B4"; // Steel blue for in progress
      case "closed":
        return "#B22222"; // Firebrick red for closed
      default:
        return "#A9A9A9"; // Dark gray for unknown status
    }
  };
  

  return (
    <Card style={{ margin: "60px 20px", padding: "10px", backgroundColor: "#ffffff", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", borderRadius: "8px", maxHeight: "100vh", overflow: "hidden" }}>
      <CardContent>
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item>
            <Typography variant="h6" style={{ fontWeight: "bold", color: "#333" }}>
              Complaints List
            </Typography>
          </Grid>
        </Grid>

        <Grid container spacing={2} alignItems="center" justifyContent="space-between" style={{ marginTop: "1px" }}>
          <Grid item xs={3}>
          {/* <TextField
              label="Search by Name"
              variant="outlined"
              size="small"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              sx={{ width: "150px" }} // Adjust width as needed
            /> */}

          <TextField
            label="Search by Date"
            type="date"
            variant="outlined"
            size="small"
            value={searchDate}
            onChange={(e) => setSearchDate(e.target.value)}
            InputLabelProps={{ shrink: true }} // Ensures label does not overlap with date value
            sx={{ width: "180px" }} // Adjust width as needed
          />

          </Grid>

          {/* Add New Button */}
          <Grid item>
            <Button 
            variant="contained"
            onClick={handleAddNewClick} 
            sx={{
              backgroundColor: "#1565c0",
              color:'#fff',
              "&:hover": {
                backgroundColor: "#0d47a1", // Darker blue on hover
              },
            }}
            >
              Raise New Complaint
            </Button>
          </Grid>
        </Grid>

        <GlobalStyles
                  styles={{
                    '.custom-sidebar-scrollbar': {
                      scrollbarWidth: 'thin', // For Firefox
                      scrollbarColor: 'grey #e0e0e0',
                    },
                    '.custom-sidebar-scrollbar::-webkit-scrollbar': {
                      width: '6px', // For WebKit-based browsers
                    },
                    '.custom-sidebar-scrollbar::-webkit-scrollbar-track': {
                      background: '#f1f1f1', // Track color
                    },
                    '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb': {
                      backgroundColor: 'grey', // Thumb color
                      borderRadius: '10px',
                    },
                    '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover': {
                      backgroundColor: '#555',
                    },
                  }}
                />

        <TableContainer 
        component={Paper} 
        style={{ marginTop: "20px", borderRadius: "8px", maxHeight: "600px", overflowY: "auto" }}
         className="custom-sidebar-scrollbar"
        >
          <Table stickyHeader>
            <TableHead>
            <TableRow>
  <TableCell
    sx={{ 
      border: "1px solid #ddd", 
      textAlign: "center", 
      backgroundColor: "#fff9c4", 
      fontSize: "14px",
      padding: "6px", // Reduced padding
      lineHeight: "1.2" // Adjust line height for compact display
    }}
  >
    S.No
  </TableCell>
  <TableCell 
    sx={{ 
      border: "1px solid #ddd", 
      textAlign: "center", 
      backgroundColor: "#fff9c4", 
      fontSize: "14px",
      padding: "6px", 
      lineHeight: "1.2"
    }}
  >
    Date
  </TableCell>
  <TableCell 
    sx={{ 
      border: "1px solid #ddd", 
      textAlign: "center", 
      backgroundColor: "#fff9c4", 
      fontSize: "14px",
      padding: "6px", 
      lineHeight: "1.2"
    }}
  >
    Time
  </TableCell>
  <TableCell 
    sx={{ 
      border: "1px solid #ddd", 
      textAlign: "center", 
      backgroundColor: "#fff9c4", 
      fontSize: "14px",
      padding: "6px", 
      lineHeight: "1.2"
    }}
  >
    Name
  </TableCell>
  <TableCell 
    sx={{ 
      border: "1px solid #ddd", 
      textAlign: "center", 
      backgroundColor: "#fff9c4", 
      fontSize: "14px",
      padding: "6px", 
      lineHeight: "1.2"
    }}
  >
    Complaint
  </TableCell>
  <TableCell 
    sx={{ 
      border: "1px solid #ddd", 
      textAlign: "center", 
      backgroundColor: "#fff9c4", 
      fontSize: "14px",
      padding: "6px", 
      lineHeight: "1.2"
    }}
  >
    Status
  </TableCell>
</TableRow>

            </TableHead>

            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={6} style={{ textAlign: "center", padding: "20px" }}>
                                          <Box display="flex" flexDirection="column" alignItems="center">
                                            <CircularProgress />
                                            <Typography variant="body2" sx={{ mt: 1 }}>
                                              Loading Data...
                                            </Typography>
                                          </Box>
                                        </TableCell>
                </TableRow>
              ) : filteredResults.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={6} style={{ textAlign: "center" }}>
                    No data found.
                  </TableCell>
                </TableRow>
              ) : (
                filteredResults.map((row, index) => (
                  <TableRow 
                  key={row.id} 
                  sx={{ 
                    backgroundColor: "white", 
                    transition: "background-color 0.3s", 
                    height: "30px" // Reduced row height 
                  }}
                >
                  <TableCell 
                    sx={{ 
                      border: "1px solid #ddd", 
                      textAlign: "center", 
                      fontSize: "14px", 
                      padding: "4px", // Reduced padding
                      lineHeight: "1.2"
                    }}
                  >
                    {index + 1}
                  </TableCell>
                  <TableCell 
                    sx={{ 
                      border: "1px solid #ddd", 
                      textAlign: "center", 
                      fontSize: "14px", 
                      padding: "4px", 
                      lineHeight: "1.2"
                    }}
                  >
                    {row.date}
                  </TableCell>
                  <TableCell 
                    sx={{ 
                      border: "1px solid #ddd", 
                      textAlign: "center", 
                      fontSize: "14px", 
                      padding: "4px", 
                      lineHeight: "1.2"
                    }}
                  >
                    {row.time}
                  </TableCell>
                  <TableCell 
                    sx={{ 
                      border: "1px solid #ddd", 
                      textAlign: "center", 
                      fontSize: "14px", 
                      padding: "4px", 
                      lineHeight: "1.2"
                    }}
                  >
                    {row.complaintRaisedName}
                  </TableCell>
                  <TableCell 
                    sx={{ 
                      border: "1px solid #ddd", 
                      textAlign: "center", 
                      fontSize: "14px", 
                      padding: "4px", 
                      lineHeight: "1.2"
                    }}
                  >
                    {row.complaintDescription}
                  </TableCell>
                  <TableCell 
                    sx={{ 
                      border: "1px solid #ddd", 
                      textAlign: "center", 
                      fontSize: "14px", 
                      padding: "4px", 
                      lineHeight: "1.2"
                    }}
                  >
                   <Button
  sx={{
    backgroundColor: `${getStatusColor(row.status)} !important`, // Force apply color
    color: "#fff",
    textTransform: "none",
    padding: "2px 8px",
    fontSize: "12px",
    minWidth: "70px",
    height: "25px",
    "&:hover": {
      backgroundColor: `${getStatusColor(row.status)} !important`, // Keep same color on hover
      opacity: 0.9,
    },
  }}
>
  {row.status}
</Button>
                  </TableCell>
                </TableRow>
                
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Dialog for Adding a New Complaint */}
        <Dialog open={isDialogOpen} onClose={handleDialogClose}>
  <DialogTitle style={{ fontWeight: "bold", color: "#333" }}>
    Raise New Complaint
  </DialogTitle>
  <DialogContent>
    <TextField
      margin="dense"
      label="Date"
      type="date"
      fullWidth
      value={newComplaint.date}
      onChange={(e) => handleInputChange("date", e.target.value)}
      InputLabelProps={{ shrink: true }}
      sx={{ "& .MuiInputBase-root": { height: "40px" }, backgroundColor: "#fff", borderRadius: "4px" }}
      error={errors.date}
      helperText={errors.date ? "Date is required" : ""}
    />
    <TextField
      margin="dense"
      label="Name"
      fullWidth
      value={newComplaint.complaintRaisedName}
      onChange={(e) => handleInputChange("complaintRaisedName", e.target.value)}
      error={errors.complaintRaisedName}
      helperText={errors.complaintRaisedName ? "Name is required" : ""}
    />
    <TextField
      margin="dense"
      label="Complaint"
      fullWidth
      multiline
      rows={3}
      value={newComplaint.complaintDescription}
      onChange={(e) => handleInputChange("complaintDescription", e.target.value)}
      error={errors.complaintDescription}
      helperText={errors.complaintDescription ? "Complaint description is required" : ""}
    />
  </DialogContent>
  <DialogActions sx={{ padding: "16px", justifyContent: "flex-end" }}>
    <Button onClick={handleDialogClose} variant="outlined">Cancel</Button>
    <Button
      onClick={handleSaveNewComplaint}
      variant="contained"
      disabled={loading}
      sx={{
        backgroundColor: "#1565c0",
        color: "#fff",
        "&:hover": { backgroundColor: "#0d47a1" },
      }}
    >
      {loading ? <CircularProgress size={24} color="inherit" /> : "Save"}
    </Button>
  </DialogActions>
</Dialog>


        <ToastContainer position="top-right" autoClose={2000} />
      </CardContent>
    </Card>
  );
}

export default TransportComplaints;